import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';

import { Glyph } from './Glyph';

export const SpinningIcon = styled(Glyph)`
  animation: ${keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`} 2s linear infinite;
`;
